import React, { useState } from "react";
import Dropzone, { DropEvent, FileRejection } from "react-dropzone";

interface ImportMediaDropzoneProps {
  fileName: string;
  handleInputChange: (event: any) => void;
  setUploadedImage: (images: string[]) => void;
  acceptedType?: string | string[];
  buttonTitle?: string;
}

export default function ImportMediaDropzone({
  fileName,
  handleInputChange,
  setUploadedImage,
  acceptedType,
  buttonTitle = "Upload",
}: ImportMediaDropzoneProps) {
  const [error, setError] = useState<string | null>(null);

  const handleDrop = (
    acceptedFiles: File[],
    _fileRejections: FileRejection[],
    _event: DropEvent
  ) => {
    if (acceptedFiles.length > 0) {
      handleInputChange({
        file: acceptedFiles,
        media: acceptedFiles.map((file) => URL.createObjectURL(file)),
        imageName: "",
        is_new: true,
      });
      // setUploadedImage(acceptedFiles.map((file) => URL.createObjectURL(file)));
      setError(null);
    } else {
      setError("Could not upload file, please try again.");
    }
  };

  return (
    <div>
      <Dropzone
        onDrop={handleDrop}
        accept={{ "image/*": [], "video/*": [] }}
        multiple={true}
      >
        {({ getRootProps, getInputProps }) => (
          <div className="flex gap-4">
            {/* Camera/Video Capture */}
            {/* <div {...getRootProps({})}>
              <button
                type="button"
                className="rounded-md bg-gray-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
              >
                <input
                  {...getInputProps({
                    accept: "image/*,video/*",
                    capture: "environment",
                  })}
                />
                Use Camera
              </button>
            </div> */}

            {/* File Upload */}
            <div {...getRootProps({})}>
              <button
                type="button"
                className="rounded-md bg-gray-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
              >
                <input
                  {...getInputProps({
                    accept: "image/*,video/*",
                  })}
                />
                {buttonTitle}
              </button>
            </div>
          </div>
        )}
      </Dropzone>

      {error && (
        <div className="text-center p-4">
          <h3 className="text-lg leading-6 font-normal text-red-500">
            {error}
          </h3>
        </div>
      )}
    </div>
  );
}
